export const PHONE_NUMBER = `(866) 784-6360`;
export const FAX_NUMBER = `(866) 784-6329`;
export const ESCALATION_EMAIL = 'stimrouterescalations@cmcopilot.com';

export const dataProduct = [
  {
    name: "A2025-Miro3D",
    value: "A2025-Miro3D",
    ndc: "768435424"
  },
  {
    name: "A2029-MiroTract",
    value: "A2029-MiroTract",
    ndc: "768437424"
  },
  {
    name: "Q4175-MiroDerm",
    value: "Q4175-MiroDerm",
    ndc: "768737424"
  },
];
export const SITE_OF_CARE_DROPDOWN = [
  {
    name: "ASC",
    value: "asc",
  },
  {
    name: "MD Office",
    value: "md_office",
  },
  {
    name: "Hospital Outpatient",
    value: "hospital_outpatient",
  },
];
